module.exports = __webpack_public_path__ + "static/media/invoice_homepage.141e310b.avif";